import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import { getSkillCardAction } from "../../store/actions";
import SkillInfoField from "./components/SkillInfoField";
import SkillImage from "./components/SkillImage";
import SkillInfoBox from './components/SkillInfoBox';
import { Typography } from "@material-ui/core";
import IconButton from '@material-ui/core/IconButton';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Button from "../../../../../ui/Button";
import Progress from "../../../../../ui/Progress";
import CardPersonBlock from "../../../../../ui/CardPersonBlock";
import CardOrganization from "../../../../../ui/CardOrganization";

const drawerWidth = 280;

const useStyles = makeStyles(theme => ({
  title: {
    flexGrow: 1
  },
  hide: {
    display: "none"
  },
  typo: {
    fontSize: 16,
    lineHeight: "24px"
  },
  typoBlock: {
    display: "block",
    "margin-bottom": 8
  },
  block: {
    marginTop: 16
  },
  devider: {
    marginTop: 16,
    display: "flex",
    alignItems: "flex-start",
    borderBottom: "1px dashed #CACCD1"
  },
  more: {
    marginTop: 24,
    marginBottom: 80,
    display: "flex",
    justifyContent: "center",
    fontWeight: '600',
    lineHeight: '15px',
    width: '240px'
  },
  cardTitle: {
    padding: "8px 0",
    borderBottom: "1px dashed #CACCD1"
  },
  progress: {
    display: "flex",
    justifyContent: "center"
  },
  drawerOpen: {
    width: drawerWidth,
    flexShrink: 0,
    zIndex: 1000,
    /*[theme.breakpoints.down("md")]: {
      position: "fixed"
    }*/
  },
  drawerClosed: {
    width: 0
  },
  drawerPaper: {
    width: drawerWidth,
    boxSizing: "border-box",
    top: 65
  },
  drawerPaperContent: {
    boxSizing: "border-box",
    padding: 20
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-start"
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    marginRight: -drawerWidth
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginRight: 0
  },
  closeButton: {
    position: 'absolute',
    opacity: 0.5,
    height: 24,
    'text-align': 'left',
    display: "flex",
    alignItems: "flex-start",
    '& .MuiIconButton-root':{
      padding: 0
    }
},
  statusBlock: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '10px 0',
  },
  typeName: {
    backgroundColor: 'rgba(0, 0, 143, 0.75)',
    color: '#ffffff',
    borderRadius: '10px',
    padding: '2px 10px',
    fontSize: '10px',
    lineHeight: '16px',
  },
  statusName: {
    color: '#ffffff',
    borderRadius: '10px',
    padding: '2px 10px',
    fontSize: '10px',
    lineHeight: '16px',
  },

  colorDevelopment: {
    backgroundColor: 'rgba(119, 136, 153, 0.7)',
  },
  colorExpertize: {
    backgroundColor: 'rgba(0, 127, 189, 0.7)',
  },
  colorApproved: {
    backgroundColor: 'rgba(255, 149, 0, 0.7)',
  },
  colorPublished: {
    backgroundColor: 'rgba(133, 196, 70, 0.8)',
  }
}));

const SkillInfoDrawer = ({
  open,
  getSkillCard,
  skillId,
  skillCard,
  history,
  hideLink,
  handleDrawerClose
}) => {
  const classes = useStyles();
  const [card, setCard] = React.useState(null);

  React.useEffect(() => {
    if (skillId !== -1) {
      setCard(null);
      getSkillCard(skillId);
    }
  }, [skillId]);

  React.useEffect(() => {
    setCard(skillCard);
  }, [skillCard]);

  const onMoreClick = () => {
    history.push(`/work/app/dict/skills/skill/${card.id}`);
  };

  const onEditClick = () => {
    history.push(`/work/app/constructor/competences/${card.id}`);
  }

  return (
    <Drawer
      className={open ? classes.drawerOpen : classes.drawerClosed}
      variant="persistent"
      anchor="right"
      open={open}
      classes={{
        paper: classes.drawerPaper
      }}
    >
    <div>
      {!hideLink && <div className={classes.closeButton}>
        <IconButton onClick={handleDrawerClose}>
          <ChevronRightIcon/>
        </IconButton>
      </div>}
      {card ? (
        <div className={classes.drawerPaperContent}>
          <SkillImage image={card.avatar || ''} />
          <div className={classes.cardTitle}>
            <Typography className={classes.typo} align="center">
              {card.name}
            </Typography>
            <div className={classes.statusBlock}>
                {(card.code || card.type) &&
                <div className={classes.typeName}>
                    {`${card.code || ''} ${card.type ? '| ' + card.type.name : ''} `}
                </div>}

                {card.sourceTypeId === 1 &&
                <div className={classes.statusName}
                     style={{backgroundColor: 'rgba(119, 136, 153, 0.7)'}}>
                    {card.statusName || 'В разработке'}
                </div>}
            </div>
          </div>

            <SkillInfoField name="Блок:">
                {card.category ? card.category.name : 'не указан'}
            </SkillInfoField>
            <SkillInfoField name="Источник:">
                {card.sourceTypeName || 'не указан'}
            </SkillInfoField>

            {(card.sourceTypeId && card.sourceTypeId === 1) && <>
            {card.org && <>
            <div className={classes.devider}></div>
            <div className={classes.block}>
              <Typography className={classes.typoBlock} variant="caption" color="textSecondary">
                Организация
              </Typography>
              <CardOrganization orgName={card.org.name} logo={card.org.logo}/>
            </div></>}

            {(card.authors && card.authors.length>0) && <>
              <div className={classes.devider}></div>
              <div className={classes.block}>
                <Typography className={classes.typoBlock} variant="caption" color="textSecondary">
                  Составители
                </Typography>
                {card.authors.map((one, index) => {
                return <CardPersonBlock personId={one.personId} image={one.personAvatar}
                        name={one.personName}
                        desc={one.orgName}/>})}
              </div>
            </>}

            {(card.expertise && card.expertise.expert) && <>
            <div className={classes.devider}></div>
            <div className={classes.block}>
              <Typography className={classes.typoBlock} variant="caption" color="textSecondary">
                Эксперт
              </Typography>
              <CardPersonBlock image={card.expertise.expert.personAvatar}
                      name={card.expertise.expert.personName}
                      desc={card.expertise.expert.orgName}/>
            </div></>}
          </>}
          {!hideLink &&
          <div className={classes.more}>
              {card.sourceTypeId === 1 ?
              <Button onClick={onEditClick}>ОТКРЫТЬ КОНСТРУКТОР</Button> :
              <Button onClick={onMoreClick}>ПОДРОБНЕЕ</Button>
              }
          </div>}

        </div>
      ) : (
        <div className={classes.progress}>
          <Progress />
        </div>
      )}
      </div>
    </Drawer>
  );
};

const mapStateToProps = state => ({
  skillCard: state.skill.skillCard
});

const mapDispatchToProps = dispatch => ({
  getSkillCard: id => dispatch(getSkillCardAction(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SkillInfoDrawer));
